import PropTypes from "prop-types";
import React, { Fragment } from "react";
import { SketchPicker } from "react-color";
import reactCSS from "reactcss";
import STSComponent from "../../STSComponent/STSComponent";
import "./css/Input.scss";

class InputField extends STSComponent {
  constructor(props) {
    super(props);
    const value = this.props.value || this.props.defaultValue || "";
    this.state = {
      inputValue: value,
      previousValue: value,
      displayColorPicker: false,
      colorPicked: false,
      color: {
        r: "241",
        g: "112",
        b: "19",
        a: "1",
      },
      value: "",
      colorHex: "",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.updateFormData = this.updateFormData.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.value !== this.props.value ||
      nextState.inputValue !== this.state.inputValue ||
      nextProps.className !== this.props.className
    );
  }

  handleClick = () => {
    this.setState({
      displayColorPicker: !this.state.displayColorPicker,
    });
  };

  handleChange = (color) => {
    this.setState({
      color: color.rgb,
      colorHex: color.hex,
      value: color.hex,
    });
  };

  handleClose = () => {
    this.setState({
      displayColorPicker: !this.state.displayColorPicker,
    });
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({
      inputValue: nextProps.value,
      previousValue: this.state.inputValue,
    });
  }

  handleInputChange = (event) => {
    const {
      location,
      inputType,
      type,
      max,
      min,
      forceUpdateOnChange,
      arrayIndex,
    } = this.props;

    const { value, id, className } = event.target;
    const valueType = arrayIndex !== undefined ? "textinputarray" : "textinput";

    if (
      location.field === "navigation" &&
      inputType === "number" &&
      /\d+/g.test(value)
    ) {
      this.updateData(location, valueType, "currentRecord", value, arrayIndex);
    }

    if (inputType === "number") {
      const re = /^[0-9\b]+$/;

      if (value === "" || re.test(value)) {
        this.setState({ inputValue: value });
      }
      return;
    }

    if (location.field === "parametersSection") {
      if (value !== this.state.inputValue) {
        this.updateData(location, valueType, id, value, arrayIndex);
      }
    }

    if (forceUpdateOnChange) {
      if (value !== this.state.inputValue) {
        this.updateData(location, valueType, id, value, arrayIndex);
      }
    }

    this.setState({
      inputValue: value,
      previousValue: this.state.inputValue,
    });

    if (location.field === "queryLine") {
      if (value !== "") {
        this.updateData(
          location,
          valueType,
          "keywordSearch",
          value,
          arrayIndex
        );
      }
    }

    if (location.field === "aliasFields") {
      if (className === "committee-alias" && value.length >= 2) {
        this.updateData(location, valueType, id, value, arrayIndex);
      } else if (className === "legislator") {
        this.updateData(location, valueType, id, value, arrayIndex);
      }
    }

    if (type === "number" && min && max && (value < min || value >= max)) {
      this.updateData(
        location,
        valueType,
        id,
        this.state.inputValue,
        arrayIndex
      );
    }
  };

  updateFormData = (event) => {
    const { location, id, arrayIndex } = this.props;
    const value = event.target.value;
    const valueType = arrayIndex !== undefined ? "textinputarray" : "textinput";

    if (!this.updateData) {
      return;
    }

    if (location.field === "queryLine") {
      this.updateData(location, valueType, id, value, arrayIndex);
    }

    if (String(value) !== String(this.state.previousValue)) {
      this.updateData(location, valueType, id, value, arrayIndex);
    }
  };

  handleKeyPress = (event) => {
    const { enterKeyPress, onKeyPress } = this.props;
    if (enterKeyPress && event.key === "Enter") {
      onKeyPress(event);
    }
  };

  rawPhoneNumber = (formattedPhoneNum, id) => {
    return formattedPhoneNum.replace(/[()-]/g, "").replace(/ +/g, "");
  };

  formatPhoneNumber = (phoneNum, id) => {
    let cleaned = ("" + phoneNum).replace(/\D/g, "");
    if (id === "sort") {
      return cleaned;
    }
    let match = cleaned.match(/^(\d{1,3})(\d{1,3})?(\d{1,4})?$/);
    if (match) {
      if (match[3]) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
      } else if (match[2]) {
        return `(${match[1]}) ${match[2]}`;
      } else if (match[1]) {
        return `(${match[1]})`;
      }
    }
    return "";
  };

  updatePhoneNumber = (e, id) => {
    const rawNum = this.rawPhoneNumber(e.target.value);
    if (rawNum.length > 10) {
      return;
    }
    return this.setState({
      inputValue: rawNum,
    });
  };

  onChange = (e, id) => {
    return id === "contact" || id === "sort"
      ? (e) => this.updatePhoneNumber(e, id)
      : this.handleInputChange;
  };

  render() {
    const styles = reactCSS({
      default: {
        swatch: {
          padding: "5px",
          background: "#fff",
          borderRadius: "1px",
          boxShadow: "0 0 0 1px rgba(0,0,0,.1)",
          display: "inline-block",
          cursor: "pointer",
        },
        popover: {
          position: "absolute",
          zIndex: "2",
          top: "25px",
          right: "0",
        },
      },
    });
    const {
      type,
      maxLength,
      picker,
      placeholder,
      className,
      id,
      disabled,
      readOnly,
      onClick,
    } = this.props;
    const show = this.state.displayColorPicker;
    const { inputValue, color } = this.state;
    return (
      <Fragment>
        <input
          type={type}
          onChange={this.onChange(id)}
          onBlur={this.updateFormData}
          value={
            id === "contact" || id === "sort"
              ? this.formatPhoneNumber(inputValue, id)
              : inputValue
          }
          placeholder={inputValue === "" ? placeholder : ""}
          maxLength={maxLength}
          onFocus={picker ? this.handleClick : null}
          onClick={picker && show ? this.handleClose : onClick}
          onKeyDown={this.handleKeyPress}
          className={className}
          id={id}
          autoComplete="off"
          disabled={disabled}
          readOnly={readOnly}
        />
        {show ? (
          <div style={styles.popover}>
            <div style={styles.cover} />
            <SketchPicker color={color} onChange={this.handleChange} />
          </div>
        ) : null}
      </Fragment>
    );
  }

  static propTypes = {
    location: PropTypes.object.isRequired,
    defaultValue: PropTypes.any,
    updateData: PropTypes.func,
    type: PropTypes.string,
    value: PropTypes.any.isRequired,
    id: PropTypes.any.isRequired,
    placeholder: PropTypes.string,
    maxLength: PropTypes.string,
    picker: PropTypes.bool,
    enterKeyPress: PropTypes.bool,
    onKeyPress: PropTypes.func,
    inputType: PropTypes.string,
    className: PropTypes.string,
    max: PropTypes.number,
    min: PropTypes.number,
    disabled: PropTypes.bool,
    forceUpdateOnChange: PropTypes.bool,
    readOnly: PropTypes.bool,
    onClick: PropTypes.func,
    arrayIndex: PropTypes.number,
  };
}

export default InputField;



// WEBPACK FOOTER //
// ./src/components/FormComponents/InputField/InputField.js